<template>
  <div ref="container" class="container">
    <div class="btn text-center" @click="showResults = !showResults">
      {{ showResults ? '隐藏搜索结果' : '显示搜索结果' }}
      <i
        :class="showResults ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
      />
    </div>
    <div v-show="showResults" class="drawer_list">
      <div
        v-for="item in dataFilter()"
        :key="item._id"
        :class="
          `drawer_list_item flex-row ${
            selectedProject && selectedProject._id === item._id ? 'drawer_list_item_actived' : ''
          }`
        "
        @click="onSelectProject(item)"
      >
        <div class="col-0 flex-column justify-center">
          <p :title="item['客户公司']">{{ item['客户公司'] }}</p>
          <el-tag :type="proStatus(item['项目状态'])" size="mini">{{ item['项目状态'] }}</el-tag>
        </div>
        <div class="col-0 item-center flex-row ellipsis mr10 ml10">{{ item['部门'] }}</div>
        <div class="col-1 drawer_list_item_last flex-column justify-center">
          <p :id="`sp${item._id}`" :title="item['项目名称']">
            <span class="drawer-link" @click.stop="onClickName(`sp${item._id}`)">{{ item['项目名称'] }}</span>
          </p>
          <p class="ft-gray">{{ formatDate(item.createdAt) }}</p>
        </div>
        <i class="project-handler el-icon-star-on" title="标记" @click.stop="mark(item)"/>
      </div>
      <div v-if="dataFilter().length === 0" class="text-center ft-gray">无数据</div>
    </div>
    <div v-show="marks.length > 0" class="shadow">
      <div class="btn text-center" @click="showMarks = !showMarks">
        {{ showMarks ? '隐藏标记项目' : '显示标记项目' }}
        <i
          :class="showMarks ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
        />
      </div>
      <div v-show="showMarks" class="drawer_list">
        <div
          v-for="(item, index) in marks"
          :key="item._id"
          :class="
            `drawer_list_item flex-row ${
              selectedProject && selectedProject._id === item._id ? 'drawer_list_item_actived' : ''
            }`
          "
          @click="onSelectProject(item)"
        >
          <div class="col-0 flex-column justify-center">
            <p :title="item['客户公司']">{{ item['客户公司'] }}</p>
            <el-tag :type="proStatus(item['项目状态'])" size="mini">{{ item['项目状态'] }}</el-tag>
          </div>
          <div class="col-0 item-center flex-row ellipsis mr10 ml10">{{ item['部门'] }}</div>
          <div class="col-1 drawer_list_item_last flex-column justify-center">
            <p :id="`sp${item._id}`" :title="item['项目名称']">
              <span class="drawer-link" @click="onClickName(`sp${item._id}`)">{{ item['项目名称'] }}</span>
            </p>
            <p class="ft-gray">{{ formatDate(item.createdAt) }}</p>
          </div>
          <i
            class="project-handler el-icon-circle-close"
            title="隐藏"
            @click.stop="removeMark(index)"
          />
        </div>
        <div v-if="marks.length === 0" class="text-center ft-gray">无数据</div>
      </div>
    </div>
    <DrawerProjectDetail v-show="pid" :pid="pid" class="col-1"/>
    <Popper
      id="drawer-popper"
      :visible.sync="popperVisible"
      :target-id="popperTarget"
      container="container"
      placement="bottom"
      class-name="shadow"
    >
      <div class="dropdown-popper">
        <a :href="`#/project20/${popperTarget.slice(2)}`" class="item" target="_blank">进入项目</a>
        <div class="item" @click="app.root.$refs.addProjectFull.visible(selectedProject._id)">进入全页</div>
        <!-- <div class="item" @click="onePiece">生成悬赏</div> -->
        <div class="item" @click="generatePic(selectedProject)">生成图片</div>
        <div class="item" @click="feedbackVisible = true">客户反馈</div>
        <div class="item" @click="addRadish(pid)">添加项目人选</div>
        <!-- <div class="item" @click="openDrawer('radish', selectedProject)">从人才库选人</div>
        <div class="item" @click="openDrawer('project', selectedProject)">从同类项目选人</div>
        <div class="item" @click="jumpToCompany(selectedProject)">从目标公司选人</div> -->
      </div>
    </Popper>
    <ProjectFeedback :visible.sync="feedbackVisible" :project="selectedProject"/>
    <generatePic ref="generatePic"/>
  </div>
</template>

<script>
import Popper from './Popper.vue'
import ProjectFeedback from './ProjectFeedback.vue'
import DrawerProjectDetail from './DrawerProjectDetail.vue'
import { onePiece } from '../constant/utils'
import generatePic from '../dialog/generatePic.vue'
// 组件已弃用

const dateFormat = require('dateformat')

export default {
  name: 'DrawerProjects',
  components: {
    Popper,
    ProjectFeedback,
    DrawerProjectDetail,
    generatePic,
  },
  props: {
    data: { type: Array, default: () => [] },
  },
  data() {
    return {
      selectedProject: undefined,
      height: undefined,
      hidden: {},
      marks: [],
      showResults: true,
      showMarks: true,
      popperVisible: false,
      popperTarget: '',
      feedbackVisible: false,
    }
  },
  computed: {
    pid() {
      return (this.selectedProject && this.selectedProject._id) || ''
    },
    app() {
      return window.app
    },
    onePiece() {
      return onePiece
    },
  },
  watch: {
    data(val) {
      this.hidden = {}
      this.showResults = true
      this.selectedProject = undefined
    },
  },
  created() {
    try {
      const marks = localStorage.getItem(`drawerMarkProjects`)
      if (!marks) return
      const parsed = JSON.parse(marks)
      if (!Array.isArray(parsed)) return
      this.marks = parsed
    } catch (error) {
      console.error(error)
    }
  },
  methods: {
    async generatePic(project) {
      await app.service('project').saveRecords({ type: '生成图片', path: '顶部导航栏-项目操作', page: '项目详情' })
      this.$refs.generatePic.open(project)
    },
    dataFilter() {
      const { hidden, data } = this
      return Object.keys(hidden).length === 0 ? data : data.filter(val => !hidden[val._id])
    },
    onSelectProject(project) {
      this.showResults = false
      if (project) {
        this.selectedProject = Object.assign({}, project)
      } else {
        this.selectedProject = undefined
      }
    },
    proStatus(status) {
      switch (status) {
        case '进展中':
          return ''
        case '已暂停':
        case '已失败':
          return 'info'
        case '已成功':
          return 'success'
        default:
          return 'info'
      }
    },
    formatDate(ts) {
      return ts ? dateFormat(new Date(parseInt(ts, 10)), 'yyyy-mm-dd') : ''
    },
    onClickName(targetId) {
      this.popperVisible = true
      this.popperTarget = targetId
    },
    mark(row) {
      if (!this.showResults) this.showResults = true
      const marks = this.marks
      const index = marks.findIndex(val => val._id === row._id)
      if (index > -1) return
      marks.push(row)
      try {
        localStorage.setItem(`drawerMarkProjects`, JSON.stringify(marks))
      } catch (error) {
        console.error(error)
      }
    },
    removeMark(index) {
      this.marks.splice(index, 1)
      try {
        localStorage.setItem(`drawerMarkProjects`, JSON.stringify(this.marks))
      } catch (error) {
        console.error(error)
      }
    },
    openDrawer(type, project) {
      if (app.root.$refs.addRadishDrawer) {
        app.root.$refs.addRadishDrawer.openDrawer(type, project)
      }
    },
    addRadish(pid) {
      app.root.$refs.radishAdd && app.root.$refs.radishAdd.open && app.root.$refs.radishAdd.open({ defaultPid: pid })
    },
    jumpToCompany(project) {
      this.openDrawer('radish', project)
      this.$nextTick(() => {
        try {
          window.app.root.$refs.addRadishDrawer.$refs.radishList.showTargetCompany()
        } catch (error) {
          console.error(error)
        }
      })
    },
  },
}
</script>

<style scoped>
.container {
  padding-top: 50px;
}
.half-height {
  max-height: 35%;
}
.shadow {
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2), 0 1px 1px rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2), 0 1px 1px rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
}
.project-handler {
  position: absolute;
  cursor: pointer;
  right: 0;
}
.el-icon-circle-close {
  color: #f44336;
  top: 5px;
  z-index: 1;
}
.el-icon-star-on {
  color: #ffc107;
  bottom: 5px;
  z-index: 1;
}
.btn {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  padding: 5px;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
  border-radius: 6px;
  margin: 5px;
}
.btn:hover {
  color: #fff;
  background-color: rgba(64, 158, 255, 0.8);
}
.bg-green {
  background-color: #26a69a;
}
/* TODO: 复用ProjectTable */
.dropdown-popper {
  border: 1px solid #eaeefb;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
}
.dropdown-popper .item {
  position: relative;
  display: block;
  width: 100%;
  padding: 10px 20px;
  color: #606266;
  background: #fff;
  cursor: pointer;
  line-height: 1;
  white-space: nowrap;
}
.dropdown-popper .item:hover {
  color: #fff;
  background: #409eff;
}
.dropdown-popper .item:hover .sub-item {
  display: block;
}
.dropdown-popper .item .sub-item {
  display: none;
  position: absolute;
  right: 100%;
  top: 0;
}
.el-table::before {
  height: 0px !important;
}
.drawer_list {
  overflow: hidden;
}
.drawer_list_item {
  position: relative;
  padding: 0 2px 2px 2px;
}
.drawer_list_item_actived {
  color: #19b1e0;
  background: rgba(25, 177, 224, 0.1);
}
.drawer_list_item::after {
  content: '';
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  height: 1px;
  background: #e0e0e0;
}
.drawer_list_item_last {
  padding-right: 10px;
  text-align: right;
}
</style>
